import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-banner-info',
  templateUrl: './banner-info.component.html',
  styleUrls: ['./banner-info.component.scss'],
  standalone: false
})

export class BannerInfoComponent {

  @Input() title = '';
  @Input() items: string[] = [];

}
